import submitForm from '../components/formSubmit'

function main() {
    const allProjectsCheckbox = document.querySelectorAll('.projects-container input[type="checkbox"]')
    const checkboxArray = Array.prototype.slice.call(allProjectsCheckbox)
    const checkboxArrayLength = checkboxArray.length
    const projectSelector = document.querySelector('.projects-selector')
    const allOptions = document.querySelectorAll('.projects-selector option')
    const optionsArray = Array.prototype.slice.call(allOptions)

    // Tick Checkbox to filter options under each region
    allProjectsCheckbox.forEach( checkbox => {
        checkbox.addEventListener('change', (e) => {
            const name = checkbox.getAttribute('name')
            const checkedStatus = e.target.checked
            const currentAllChecked = checkboxArray.filter( el => el.checked == true )
            const currentNotChecked = checkboxArray.filter( el => el.checked == false )
            const currentAllCheckedName = currentAllChecked.map( el => el.getAttribute('name'))
            const currentNotCheckedName = currentNotChecked.map( el => el.getAttribute('name'))
            
            // Not checked projects hide
            const notCheckedProjects = optionsArray.filter( option => {
                const category = option.dataset.project
                return currentNotCheckedName.includes(category)
            })
            notCheckedProjects.forEach( option => {
                option.classList.remove('d-block')
            })
            
            // Checked projects show
            const checkedProject = optionsArray.filter( option => {
                const category = option.dataset.project
                return currentAllCheckedName.includes(category)
            })
            checkedProject.forEach( option => {
                option.classList.add('d-block')
            })

            // Show all projects if all checkbox not checked
            if (currentNotChecked.length == checkboxArrayLength) {
                allOptions.forEach( option => {
                    option.classList.add('d-block')
                })
            }

            // Show all projects if select 'all-projects'
            if (checkedStatus && name == 'all-projects') {
                allOptions.forEach( option => {
                    option.classList.add('show-all')
                })
            }

            // Remove 'show-all' class if deselect 'all-projects'
            if (!checkedStatus && name == 'all-projects') {
                allOptions.forEach( option => {
                    option.classList.remove('show-all')
                })
            }
        })
    })

    submitForm()
}

export default main;
